// @flow

/** tell if cookies are available from the current environement */
export const isCookieAvailable = (): boolean =>
  typeof document !== 'undefined' && !!document.cookie;

/** checks if a particular cookie exists */
export const hasCookie = (key: string): boolean =>
  isCookieAvailable() && !!document.cookie.includes(`${key}=`);

/** return the value of a specific cookie */
export const getCookie = (key: string): void | string =>
  hasCookie(key)
    ? document.cookie
        .split('; ')
        .find(row => row.startsWith(`${key}=`))
        ?.split('=')[1]
    : undefined;

/** set a cookie */
export const setCookie = (
  key: string,
  opt: {
    value?: string,
    domain?: string,
    expires?: string,
  },
): void => {
  if (isCookieAvailable()) {
    const cookieDomain =
      opt.domain || window.location.host.replace(/.*?\./, '');
    const cookieExpires = opt.expires || 'Thu, 01 Jan 1970 00:00:00 UTC';
    document.cookie = `${key}=${opt.value || ''};domain=${cookieDomain};sameSite=Lax;secure;path=/;expires=${cookieExpires};`;
  }
};
